import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { label: "The Pack", href: "#pack" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Cotton Refills", href: "#cotton" },
  { label: "Comfort Range", href: "#range" },
  { label: "Colours", href: "#colours" },
  { label: "Shop", href: "#shop" },
  { label: "Retailers", href: "#retailers" },
  { label: "Safety", href: "#safety" },
  { label: "Safer Sleep", href: "#safer-sleep" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled || open
          ? "bg-white/85 shadow-[0_8px_30px_-12px_rgba(27,79,160,0.25)] backdrop-blur-xl"
          : "bg-white/40 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-5 xl:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="text-[13px] font-semibold text-slate-600 transition-colors duration-300 hover:text-binky-pink"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-register-button"
            onClick={() => go("#register")}
            className="hidden rounded-full bg-binky-pink px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-binky-pink/30 transition-transform duration-300 hover:scale-105 active:scale-95 sm:inline-flex"
          >
            Register Your Interest
          </button>
          <button
            data-testid="nav-menu-button"
            onClick={() => setOpen(!open)}
            className="inline-flex rounded-full p-2 text-binky-blue transition-colors hover:bg-binky-blue/5 xl:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="border-t border-binky-blue/10 bg-white/95 px-5 pb-6 pt-3 backdrop-blur-xl xl:hidden"
        >
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="block w-full py-3 text-left text-base font-semibold text-slate-700 transition-colors hover:text-binky-pink"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-register-button"
            onClick={() => go("#register")}
            className="mt-3 w-full rounded-full bg-binky-pink px-5 py-3 text-sm font-bold text-white"
          >
            Register Your Interest
          </button>
        </div>
      )}
    </header>
  );
};
